// Styles
import "./sort-status.scss";

/*
	Виды сртировки:
		ASC - от меньшего к большему
		DESC - от большего к меньшему
		UNACTIVE - неактивный
*/

interface Props {
	status: string;
}

export const SortStatus = ({ status }: Props) => {
	const s = status.toLowerCase();
	return (
		<div className='sort-status'>
			{s === "asc" && (
				<div className='sort-status__asc'>
					<img src='/img/icons/triangle-arrow-cropped.png' alt='arrow' />
				</div>
			)}
			{s === "desc" && (
				<div className='sort-status__desc'>
					<img src='/img/icons/triangle-arrow-cropped.png' alt='arrow' />
				</div>
			)}
			{s === "unactive" && (
				<div className='sort-status__unactive'>
					<img src='/img/icons/triangle-arrow-cropped.png' alt='arrow' />
					<img src='/img/icons/triangle-arrow-cropped.png' alt='arrow' />
				</div>
			)}
		</div>
	);
};
